export default __webpack_public_path__ + "static/media/snack.dd48fa7a.svg";